class FileApiError extends Error {
    constructor(message,originalError = null) {
        super(message);
        this.name = 'FileApiError';
        this.originalError = originalError;
        Object.setPrototypeOf(this, FileApiError.prototype);
        if (Error.captureStackTrace){
            Error.captureStackTrace(this, FileApiError)
        }
    }
}
function createErrorClass(name) {
    return class extends FileApiError {
        constructor(message, originalError) {
            super(message, originalError);
            this.name = name;
        }
    };
}
export const FileDeleteError = createErrorClass('FileDeleteError')
export const DirectUploadError = createErrorClass('DirectUploadError')
export const RequirePresignedUrlError = createErrorClass('RequirePresignedUrlError')
export const S3DBSyncronizeError = createErrorClass('S3DBSyncronizeError')
export const NotifyUploadError = createErrorClass('NotifyUploadError')

export default FileApiError